module.exports = __webpack_public_path__ + "img/xz_line_tail_2.1b71fb44.svg";